import React from "react";

import FormInput from "../../components/form-input/form-input.component";
import CustomButton from "../../components/custom-button/custom-button.component";
import { createNewPet } from "../../firebase/firebase.utils";
import firebase from "../../firebase/firebase.utils";
import FileUploader from "react-firebase-file-uploader";

// import { auth, createUserProfileDocument } from '../../firebase/firebase.utils';

import "./add-edit-pet.styles.scss";

class AddEditPet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      microchip: "",
      petName: "",
      owner: "",
      petType: "",
      sex: "",
      DOB: "",
      breed: "",
      color: "",
      motherID: "",
      fatherID: "",
      ownerAddress: "",
      ownerID: "",
      ownerPhone: "",
      registrationID: "",
      photos: [],
      isEdit: false,
    };
  }

  clearState() {
    this.setState({
      files: [],
      microchip: "",
      petName: "",
      owner: "",
      petType: "",
      sex: "",
      DOB: "",
      breed: "",
      color: "",
      motherID: "",
      fatherID: "",
      ownerAddress: "",
      ownerID: "",
      ownerPhone: "",
      registrationID: "",
      photos: [],
      isEdit: false,
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.clearState();
    }
  }

  componentDidMount() {
    if (this.props.location.state)
      this.setState({
        ...this.props.location.state.data,
        isEdit: true,
        microchip: this.props.location.state.microchip,
      });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const {files, ...data} = this.state;
    await createNewPet(data);
    alert("Thành công!");
    this.props.history.push('/');
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  // handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  // handleProgress = (progress) => this.setState({ progress });
  handleUploadError = (error) => {
    // this.setState({ isUploading: false });
    console.error(error);
  };
  handleUploadSuccess = (filename) => {
    // this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref(`images/${this.state.microchip}`)
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        this.setState({ photos: [...this.state.photos, url] });
      })
      .then(() => {
        alert(`Up ảnh ${filename} thành công!`);
      });
  };

  uploadPhotos  = () => {
    const { files } = this.state;
    files.forEach((file) => {
      this.fileUploader.startUpload(file);
    });
  }
  /**
   * Custom onChange event handler
   * Store selected files in the state
   */
  customOnChangeHandler = (event) => {
    const {
      target: { files },
    } = event;
    const filesToStore = [];
    for(let i = 0; i< files.length; i++)
      filesToStore.push(files[i]);
    this.setState({ files: filesToStore });
  };

  render() {
    const {
      petName,
      microchip,
      breed,
      DOB,
      color,
      sex,
      owner,
      motherID,
      fatherID,
      ownerAddress,
      ownerID,
      ownerPhone,
      registrationID,
    } = this.state;
    return (
      <div className="wrapper">
        {!this.state.isEdit ? (
          <h2 className="title">Tạo thông tin thú cưng mới</h2>
        ) : (
          <h2 className="title">Cập nhật thông tin thú cưng</h2>
        )}

        {/* <span>Điền thông tin</span> */}
        <form className="create-new-form" onSubmit={this.handleSubmit}>
          <div className="leftColumn">
            <h4>THÔNG TIN THÚ NUÔI</h4>
            <FormInput
              type="text"
              name="petName"
              value={petName}
              onChange={this.handleChange}
              label="Tên thú nuôi"
              required
            />
            <FormInput
              type="text"
              name="microchip"
              value={microchip}
              onChange={this.handleChange}
              label="Số microchip"
              required
            />

            <FormInput
              type="text"
              name="breed"
              value={breed}
              onChange={this.handleChange}
              label="Giống chó"
            />
            <FormInput
              type="text"
              name="DOB"
              value={DOB}
              onChange={this.handleChange}
              label="Ngày sinh"
            />
            <FormInput
              type="text"
              name="color"
              value={color}
              onChange={this.handleChange}
              label="Màu sắc"
            />
            <FormInput
              type="text"
              name="sex"
              value={sex}
              onChange={this.handleChange}
              label="Giới tính"
            />
            <FormInput
              type="text"
              name="fatherID"
              value={fatherID}
              onChange={this.handleChange}
              label="Số microchip của cha"
            />
            <FormInput
              type="text"
              name="motherID"
              value={motherID}
              onChange={this.handleChange}
              label="Số microchip của mẹ"
            />
          </div>
          <div>
            <h4>THÔNG TIN CHỦ SỞ HỮU</h4>
            <FormInput
              type="text"
              name="owner"
              value={owner}
              onChange={this.handleChange}
              label="Họ tên"
              required
            />
            <FormInput
              type="text"
              name="ownerID"
              value={ownerID}
              onChange={this.handleChange}
              label="CMTND"
            />
            <FormInput
              type="text"
              name="ownerAddress"
              value={ownerAddress}
              onChange={this.handleChange}
              label="Địa chỉ"
            />
            <FormInput
              type="text"
              name="ownerPhone"
              value={ownerPhone}
              onChange={this.handleChange}
              label="Điện thoại"
            />
            <FormInput
              type="text"
              name="registrationID"
              value={registrationID}
              onChange={this.handleChange}
              label="Mã đăng kí"
            />
            <label
              style={{
                backgroundColor: "steelblue",
                color: "white",
                padding: 10,
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              <FileUploader
                accept="image/*"
                name="avatar"
                randomizeFilename
                storageRef={firebase
                  .storage()
                  .ref(`images/${this.state.microchip}`)}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
                multiple
                onChange={this.customOnChangeHandler} // ⇐ Call your handler
                ref={instance => { this.fileUploader = instance; } }  // ⇐ reference the component
              />
            </label>
            <button type ="button" onClick={this.uploadPhotos}> Up ảnh</button>
            <hr />
            {!this.state.isEdit ? (
              <CustomButton type="submit" onSubmit={this.handleSubmit}>
                Tạo thú cưng mới
              </CustomButton>
            ) : (
              <CustomButton type="submit" onSubmit={this.handleSubmit}>
                Lưu thay đổi
              </CustomButton>
            )}
          </div>
        </form>
      </div>
    );
  }
}

export default AddEditPet;
